/**
 * Medicare Card Number validation check
 *
 * has 10 digits
 * checksum validation check
 *
 * @param {string} cardNumber - The input Medicare Card number
 * @return {boolean} - If the Medicare Card number pass the checksum check, return true, else return false
 */

export const MEDICARE_CARD_CHECKSUM_VALIDATOR = (cardNumber) => {
  if (cardNumber !== undefined && cardNumber !== null) {
    // Need to strip out any input masking that may have occurred, so remove the spacing from entire string
    const trimmedCardNumber = cardNumber.replace(/ /g, '');
    const reg = /^\d{10}$/;
    const weights = [1, 3, 7, 9, 1, 3, 7, 9];
    if (reg.test(trimmedCardNumber)) {
      const cardNumberArray = trimmedCardNumber.split('');
      let sum = 0;
      for (let i = 0; i < weights.length; i++) {
        sum += weights[i] * Number.parseInt(cardNumberArray[i], 10);
      }
      return sum % 10 === Number.parseInt(cardNumberArray[8], 10);
    }
  }
  return false;
};
// TODO - Since the following validator does the same thing as isPastDate validator in Utils, it might potentially be made redundant. Need to discuss and proceed accordingly.
/**
 * Check if input medicare card valid date is a future date, allow the current month to be a valid date
 * @param {string} date - The date needed to be checked if it is expired
 * @returns {boolean} - If the date is not expired, return true, else return false
 */
export const MEDICARE_CARD_EXPIRY_DATE_VALIDATOR = (date) => {
  const currentYear = new Date().getFullYear();
  const currentMonth = new Date().getMonth() + 1;
  if (date !== undefined && date !== null && date.length === 9) {
    const mm = date.slice(0, 2);
    const yyyy = date.slice(-4);
    if (yyyy > currentYear) {
      return true;
    }
    if (parseInt(yyyy, 10) === currentYear && parseInt(mm, 10) >= currentMonth) {
      return true;
    }
  }
  return false;
};

/**
 * Check if input medicare card valid date match the regex
 * @param {string} date - The date needed to be checked in the format of 'MM / YYYY'
 * @returns {boolean} - If the date match the pattern, return true, else return false
 */
export const MEDICARE_CARD_EXPIRY_DATE_PATTERN_CHECK = (date) => {
  const reg =
    /^(((0[1-9]|[12][0-9]|3[01])(\s\/\s)(0[13578]|1[02])|(0[1-9]|[12][0-9]|30)(\s\/\s)(0[469]|11)|(0[1-9]|1\d|2[0-8])(\s\/\s)02)(\s\/\s)\d{4}|29(\s\/\s)02(\s\/\s)(\d{2}(0[48]|[2468][048]|[13579][26])|([02468][048]|[1359][26])00))$/;

  if (date !== undefined && date !== null && reg.test(date)) {
    return true;
  }
  return false;
};
